
import Vue from 'vue'
import { auth } from '@/firebase'

const forceRefresh = false

export default Vue.extend({
  data: () => ({
    token: undefined as string | undefined,
    error: undefined as Error | undefined,
  }),
  methods: {
    getToken() {
      auth
        ?.currentUser()
        ?.getIdToken(forceRefresh)
        .then((idToken) => {
          this.token = idToken
        })
        .catch((error) => {
          this.error = error
        })
    },
  },
})
